import { isEqual } from "lodash";
import { useSelector } from "react-redux";
import { useRequest } from "redux-query-react";
import { DatapointsEntityType, postDatapoints, useGetDatapointsMetadata } from "api/ux/src";
import { objectToHash } from "common/object-helper";
import { useGetUnitOfAreaKey, useGetUserAllocationKey, useGetUserCommitmentCalculation } from "components/frame/hooks/use-user-preferences";
import { DataExportGridTypes } from "components/pages/administration/export-data-administration/insExportDataAdministration";
import { buildPipeline } from "hooks/widget-data/datapoints-api/pipeline";
import { allocationKeyEnumValues, commitmentCalculationEnumValues, globalQueryStateSelector, unitOfAreaKeyEnumValue } from "hooks/widget-data/use-datapoints";
import { FundDataExportTypes } from "./shared/dashboardTypeToEntityType";
export const useCustomDataDatapointsRequest = (dimensions, measures, stateId, currency, requestId = "CustomData", filters = []) => {
    const allocationKey = useGetUserAllocationKey(), commitmentCalculation = useGetUserCommitmentCalculation(), unitOfArea = useGetUnitOfAreaKey();
    if (!allocationKey || !unitOfArea || !commitmentCalculation) {
        return undefined;
    }
    const date = new Date();
    date.setUTCHours(0, 0, 0, 0);
    const requestParameters = {
        datapointsRequest: {
            allocationKey: allocationKeyEnumValues(allocationKey),
            asOfDate: date,
            commitmentCalculation: commitmentCalculationEnumValues(commitmentCalculation),
            entityId: stateId === DataExportGridTypes.Funds ? FundDataExportTypes.AllFunds : FundDataExportTypes.All,
            entityType: DatapointsEntityType.Portfolio,
            filters: filters.length ? filters : undefined,
            requests: [{ dimensions, id: requestId, measures }],
            selectedCurrency: currency || "USD",
            unitOfArea: unitOfAreaKeyEnumValue(unitOfArea)
        }
    };
    if (requestParameters.datapointsRequest) {
        requestParameters.datapointsRequest.id = objectToHash(requestParameters);
    }
    return requestParameters;
};
const useDatapoints = (requestParameters) => {
    const dataKey = requestParameters?.datapointsRequest?.id || "";
    const [, ForceRefresh] = useRequest(requestParameters ? postDatapoints(requestParameters, { queryKey: `PostDatapoints-${dataKey}` }) : null);
    const globalQueryState = useSelector((state) => globalQueryStateSelector(state, "PostDatapoints", dataKey), isEqual);
    return [useSelector((state) => state.entities.Datapoints[dataKey]), globalQueryState, ForceRefresh];
};
export const useGetCustomDataDatapoints = (request) => {
    const [, metadataQueryState] = useGetDatapointsMetadata();
    const [responses, queryState, refresh] = useDatapoints(metadataQueryState.isFinished ? request : undefined);
    let data = [];
    if (responses?.responses) {
        const pipeline = buildPipeline({
            compositeObjectBuilder: {
                dimensions: request?.datapointsRequest?.requests[0]?.dimensions?.map((d) => d.name || "") || [],
                measures: request?.datapointsRequest?.requests[0]?.measures?.map((m) => m.name || "") || []
            }
        });
        if (responses?.responses?.length) {
            const response = responses.responses;
            data = pipeline(response)[0].root ?? [];
        }
    }
    return [data, queryState, refresh];
};
